export default __webpack_public_path__ + "041ea05.png";